import {
    Card,
    CardBody,
    CardHeader,
    Stat,
    Heading,
    StatNumber,
    Circle,
    Stack
} from '@chakra-ui/react'

export type DetailsCardProps = {
    stats: number
    label: string
    icon: React.ReactNode | any
    bg?: string
    textColor?: string
}

export const InfoCard = ({
    stats,
    label,
    icon: Icon,
    bg = 'brand.700',
    textColor = 'white'
}: DetailsCardProps) => (
    <Card
        bg={bg}
        maxW="sm"
        direction={{ base: 'column', sm: 'row' }}
        overflow="hidden"
        variant={'elevated'}
    >
        <CardHeader
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
            }}
        >
            <Circle
                size="50px"
                bg="white"
                borderWidth="1px"
                borderColor="gray.300"
                borderRadius={'xl'}
            >
                <div style={{ fontSize: '1.3rem' }}>{Icon}</div>
            </Circle>
        </CardHeader>
        <Stack>
            <CardBody>
                <Stat>
                    <Heading color={textColor} size="xs" textTransform="uppercase">
                        {label}
                    </Heading>
                    <StatNumber color={textColor}>{stats}</StatNumber>
                </Stat>
            </CardBody>
        </Stack>
    </Card>
)
